// ref : https://github.com/e-MediSkill/eMediSkill-webApp/blob/version2/src/assets/countryCode.json
export const onlyCountries = [
    {
        "countryCode": "+91",
        "value": "India",
        "label": "India"
    },
    {
        "countryCode": "+93",
        "value": "Afghanistan",
        "label": "Afghanistan"
    },
    {
        "countryCode": "+355",
        "value": "Albania",
        "label": "Albania"
    },
    {
        "countryCode": "+213",
        "value": "Algeria",
        "label": "Algeria"
    },
    {
        "countryCode": "+1 684",
        "value": "American Samoa",
        "label": "American Samoa"
    },
    {
        "countryCode": "+376",
        "value": "Andorra",
        "label": "Andorra"
    },
    {
        "countryCode": "+244",
        "value": "Angola",
        "label": "Angola"
    },
    {
        "countryCode": "+1 264",
        "value": "Anguilla",
        "label": "Anguilla"
    },
    {
        "countryCode": "+1 268",
        "value": "Antigua and Barbuda",
        "label": "Antigua and Barbuda"
    },
    {
        "countryCode": "+54",
        "value": "Argentina",
        "label": "Argentina"
    },
    {
        "countryCode": "+374",
        "value": "Armenia",
        "label": "Armenia"
    },
    {
        "countryCode": "+297",
        "value": "Aruba",
        "label": "Aruba"
    },
    {
        "countryCode": "+61",
        "value": "Australia",
        "label": "Australia"
    },
    {
        "countryCode": "+43",
        "value": "Austria",
        "label": "Austria"
    },
    {
        "countryCode": "+994",
        "value": "Azerbaijan",
        "label": "Azerbaijan"
    },
    {
        "countryCode": "+1 242",
        "value": "Bahamas",
        "label": "Bahamas"
    },
    {
        "countryCode": "+973",
        "value": "Bahrain",
        "label": "Bahrain"
    },
    {
        "countryCode": "+880",
        "value": "Bangladesh",
        "label": "Bangladesh"
    },
    {
        "countryCode": "+1 246",
        "value": "Barbados",
        "label": "Barbados"
    },
    {
        "countryCode": "+375",
        "value": "Belarus",
        "label": "Belarus"
    },
    {
        "countryCode": "+32",
        "value": "Belgium",
        "label": "Belgium"
    },
    {
        "countryCode": "+501",
        "value": "Belize",
        "label": "Belize"
    },
    {
        "countryCode": "+229",
        "value": "Benin",
        "label": "Benin"
    },
    {
        "countryCode": "+1 441",
        "value": "Bermuda",
        "label": "Bermuda"
    },
    {
        "countryCode": "+975",
        "value": "Bhutan",
        "label": "Bhutan"
    },
    {
        "countryCode": "+591",
        "value": "Bolivia",
        "label": "Bolivia"
    },
    {
        "countryCode": "+387",
        "value": "Bosnia and Herzegovina",
        "label": "Bosnia and Herzegovina"
    },
    {
        "countryCode": "+267",
        "value": "Botswana",
        "label": "Botswana"
    },
    {
        "countryCode": "+55",
        "value": "Brazil",
        "label": "Brazil"
    },
    {
        "countryCode": "+246",
        "value": "British Indian Ocean Territory",
        "label": "British Indian Ocean Territory"
    },
    {
        "countryCode": "+673",
        "value": "Brunei Darussalam",
        "label": "Brunei Darussalam"
    },
    {
        "countryCode": "+359",
        "value": "Bulgaria",
        "label": "Bulgaria"
    },
    {
        "countryCode": "+226",
        "value": "Burkina Faso",
        "label": "Burkina Faso"
    },
    {
        "countryCode": "+257",
        "value": "Burundi",
        "label": "Burundi"
    },
    {
        "countryCode": "+855",
        "value": "Cambodia",
        "label": "Cambodia"
    },
    {
        "countryCode": "+237",
        "value": "Cameroon",
        "label": "Cameroon"
    },
    {
        "countryCode": "+1",
        "value": "Canada",
        "label": "Canada"
    },
    {
        "countryCode": "+238",
        "value": "Cape Verde",
        "label": "Cape Verde"
    },
    {
        "countryCode": "+1 345",
        "value": "Cayman Islands",
        "label": "Cayman Islands"
    },
    {
        "countryCode": "+236",
        "value": "Central African Republic",
        "label": "Central African Republic"
    },
    {
        "countryCode": "+235",
        "value": "Chad",
        "label": "Chad"
    },
    {
        "countryCode": "+56",
        "value": "Chile",
        "label": "Chile"
    },
    {
        "countryCode": "+86",
        "value": "China",
        "label": "China"
    },
    {
        "countryCode": "+61 89164",
        "value": "Christmas Island",
        "label": "Christmas Island"
    },
    {
        "countryCode": "+61 89162",
        "value": "Cocos (Keeling) Islands",
        "label": "Cocos (Keeling) Islands"
    },
    {
        "countryCode": "+57",
        "value": "Colombia",
        "label": "Colombia"
    },
    {
        "countryCode": "+269",
        "value": "Comoros",
        "label": "Comoros"
    },
    {
        "countryCode": "+682",
        "value": "Cook Islands",
        "label": "Cook Islands"
    },
    {
        "countryCode": "+506",
        "value": "Costa Rica",
        "label": "Costa Rica"
    },
    {
        "countryCode": "+385",
        "value": "Croatia",
        "label": "Croatia"
    },
    {
        "countryCode": "+53",
        "value": "Cuba",
        "label": "Cuba"
    },
    {
        "countryCode": "+599 9",
        "value": "Curaçao",
        "label": "Curaçao"
    },
    {
        "countryCode": "+357",
        "value": "Cyprus",
        "label": "Cyprus"
    },
    {
        "countryCode": "+420",
        "value": "Czech Republic",
        "label": "Czech Republic"
    },
    {
        "countryCode": "+45",
        "value": "Denmark",
        "label": "Denmark"
    },
    {
        "countryCode": "+253",
        "value": "Djibouti",
        "label": "Djibouti"
    },
    {
        "countryCode": "+1 767",
        "value": "Dominica",
        "label": "Dominica"
    },
    {
        "countryCode": "+1 809, 1 829,\n1 849",
        "value": "Dominican Republic",
        "label": "Dominican Republic"
    },
    {
        "countryCode": "+593",
        "value": "Ecuador",
        "label": "Ecuador"
    },
    {
        "countryCode": "+20",
        "value": "Egypt",
        "label": "Egypt"
    },
    {
        "countryCode": "+503",
        "value": "El Salvador",
        "label": "El Salvador"
    },
    {
        "countryCode": "+240",
        "value": "Equatorial Guinea",
        "label": "Equatorial Guinea"
    },
    {
        "countryCode": "+291",
        "value": "Eritrea",
        "label": "Eritrea"
    },
    {
        "countryCode": "+372",
        "value": "Estonia",
        "label": "Estonia"
    },
    {
        "countryCode": "+268",
        "value": "Eswatini",
        "label": "Eswatini"
    },
    {
        "countryCode": "+251",
        "value": "Ethiopia",
        "label": "Ethiopia"
    },
    {
        "countryCode": "+298",
        "value": "Faroe Islands",
        "label": "Faroe Islands"
    },
    {
        "countryCode": "+679",
        "value": "Fiji",
        "label": "Fiji"
    },
    {
        "countryCode": "+358",
        "value": "Finland",
        "label": "Finland"
    },
    {
        "countryCode": "+33",
        "value": "France",
        "label": "France"
    },
    {
        "countryCode": "+594",
        "value": "French Guiana",
        "label": "French Guiana"
    },
    {
        "countryCode": "+689",
        "value": "French Polynesia",
        "label": "French Polynesia"
    },
    {
        "countryCode": "+241",
        "value": "Gabon",
        "label": "Gabon"
    },
    {
        "countryCode": "+995",
        "value": "Georgia",
        "label": "Georgia"
    },
    {
        "countryCode": "+49",
        "value": "Germany",
        "label": "Germany"
    },
    {
        "countryCode": "+233",
        "value": "Ghana",
        "label": "Ghana"
    },
    {
        "countryCode": "+350",
        "value": "Gibraltar",
        "label": "Gibraltar"
    },
    {
        "countryCode": "+30",
        "value": "Greece",
        "label": "Greece"
    },
    {
        "countryCode": "+299",
        "value": "Greenland",
        "label": "Greenland"
    },
    {
        "countryCode": "+1 473",
        "value": "Grenada",
        "label": "Grenada"
    },
    {
        "countryCode": "+590",
        "value": "Guadeloupe",
        "label": "Guadeloupe"
    },
    {
        "countryCode": "+1 671",
        "value": "Guam",
        "label": "Guam"
    },
    {
        "countryCode": "+502",
        "value": "Guatemala",
        "label": "Guatemala"
    },
    {
        "countryCode": "+44 1481, 44 7781,\n44 7839, 44 7911",
        "value": "Guernsey",
        "label": "Guernsey"
    },
    {
        "countryCode": "+224",
        "value": "Guinea",
        "label": "Guinea"
    },
    {
        "countryCode": "+245",
        "value": "Guinea-Bissau",
        "label": "Guinea-Bissau"
    },
    {
        "countryCode": "+592",
        "value": "Guyana",
        "label": "Guyana"
    },
    {
        "countryCode": "+509",
        "value": "Haiti",
        "label": "Haiti"
    },
    {
        "countryCode": "+504",
        "value": "Honduras",
        "label": "Honduras"
    },
    {
        "countryCode": "+852",
        "value": "Hong Kong",
        "label": "Hong Kong"
    },
    {
        "countryCode": "+36",
        "value": "Hungary",
        "label": "Hungary"
    },
    {
        "countryCode": "+354",
        "value": "Iceland",
        "label": "Iceland"
    },
    {
        "countryCode": "+62",
        "value": "Indonesia",
        "label": "Indonesia"
    },
    {
        "countryCode": "+964",
        "value": "Iraq",
        "label": "Iraq"
    },
    {
        "countryCode": "+353",
        "value": "Ireland",
        "label": "Ireland"
    },
    {
        "countryCode": "+44 1624, 44 7524,\n44 7624, 44 7924",
        "value": "Isle of Man",
        "label": "Isle of Man"
    },
    {
        "countryCode": "+972",
        "value": "Israel",
        "label": "Israel"
    },
    {
        "countryCode": "+39",
        "value": "Italy",
        "label": "Italy"
    },
    {
        "countryCode": "+1 658, 1 876",
        "value": "Jamaica",
        "label": "Jamaica"
    },
    {
        "countryCode": "+81",
        "value": "Japan",
        "label": "Japan"
    },
    {
        "countryCode": "+44 1534",
        "value": "Jersey",
        "label": "Jersey"
    },
    {
        "countryCode": "+962",
        "value": "Jordan",
        "label": "Jordan"
    },
    {
        "countryCode": "+997 (also 7 until 2025)",
        "value": "Kazakhstan",
        "label": "Kazakhstan"
    },
    {
        "countryCode": "+254",
        "value": "Kenya",
        "label": "Kenya"
    },
    {
        "countryCode": "+686",
        "value": "Kiribati",
        "label": "Kiribati"
    },
    {
        "countryCode": "+383",
        "value": "Kosovo",
        "label": "Kosovo"
    },
    {
        "countryCode": "+965",
        "value": "Kuwait",
        "label": "Kuwait"
    },
    {
        "countryCode": "+996",
        "value": "Kyrgyzstan",
        "label": "Kyrgyzstan"
    },
    {
        "countryCode": "+856",
        "value": "Laos",
        "label": "Laos"
    },
    {
        "countryCode": "+371",
        "value": "Latvia",
        "label": "Latvia"
    },
    {
        "countryCode": "+961",
        "value": "Lebanon",
        "label": "Lebanon"
    },
    {
        "countryCode": "+266",
        "value": "Lesotho",
        "label": "Lesotho"
    },
    {
        "countryCode": "+231",
        "value": "Liberia",
        "label": "Liberia"
    },
    {
        "countryCode": "+218",
        "value": "Libya",
        "label": "Libya"
    },
    {
        "countryCode": "+423",
        "value": "Liechtenstein",
        "label": "Liechtenstein"
    },
    {
        "countryCode": "+370",
        "value": "Lithuania",
        "label": "Lithuania"
    },
    {
        "countryCode": "+352",
        "value": "Luxembourg",
        "label": "Luxembourg"
    },
    {
        "countryCode": "+261",
        "value": "Madagascar",
        "label": "Madagascar"
    },
    {
        "countryCode": "+265",
        "value": "Malawi",
        "label": "Malawi"
    },
    {
        "countryCode": "+60",
        "value": "Malaysia",
        "label": "Malaysia"
    },
    {
        "countryCode": "+960",
        "value": "Maldives",
        "label": "Maldives"
    },
    {
        "countryCode": "+223",
        "value": "Mali",
        "label": "Mali"
    },
    {
        "countryCode": "+356",
        "value": "Malta",
        "label": "Malta"
    },
    {
        "countryCode": "+692",
        "value": "Marshall Islands",
        "label": "Marshall Islands"
    },
    {
        "countryCode": "+596",
        "value": "Martinique",
        "label": "Martinique"
    },
    {
        "countryCode": "+222",
        "value": "Mauritania",
        "label": "Mauritania"
    },
    {
        "countryCode": "+230",
        "value": "Mauritius",
        "label": "Mauritius"
    },
    {
        "countryCode": "+262 269, 262 639",
        "value": "Mayotte",
        "label": "Mayotte"
    },
    {
        "countryCode": "+52",
        "value": "Mexico",
        "label": "Mexico"
    },
    {
        "countryCode": "+691",
        "value": "Micronesia, Federated States of",
        "label": "Micronesia, Federated States of"
    },
    {
        "countryCode": "+373",
        "value": "Moldova",
        "label": "Moldova"
    },
    {
        "countryCode": "+377",
        "value": "Monaco",
        "label": "Monaco"
    },
    {
        "countryCode": "+976",
        "value": "Mongolia",
        "label": "Mongolia"
    },
    {
        "countryCode": "+382",
        "value": "Montenegro",
        "label": "Montenegro"
    },
    {
        "countryCode": "+1 664",
        "value": "Montserrat",
        "label": "Montserrat"
    },
    {
        "countryCode": "+212",
        "value": "Morocco",
        "label": "Morocco"
    },
    {
        "countryCode": "+258",
        "value": "Mozambique",
        "label": "Mozambique"
    },
    {
        "countryCode": "+95",
        "value": "Myanmar",
        "label": "Myanmar"
    },
    {
        "countryCode": "+264",
        "value": "Namibia",
        "label": "Namibia"
    },
    {
        "countryCode": "+674",
        "value": "Nauru",
        "label": "Nauru"
    },
    {
        "countryCode": "+977",
        "value": "Nepal",
        "label": "Nepal"
    },
    {
        "countryCode": "+31",
        "value": "Netherlands",
        "label": "Netherlands"
    },
    {
        "countryCode": "+687",
        "value": "New Caledonia",
        "label": "New Caledonia"
    },
    {
        "countryCode": "+64",
        "value": "New Zealand",
        "label": "New Zealand"
    },
    {
        "countryCode": "+505",
        "value": "Nicaragua",
        "label": "Nicaragua"
    },
    {
        "countryCode": "+227",
        "value": "Niger",
        "label": "Niger"
    },
    {
        "countryCode": "+234",
        "value": "Nigeria",
        "label": "Nigeria"
    },
    {
        "countryCode": "+683",
        "value": "Niue",
        "label": "Niue"
    },
    {
        "countryCode": "+672 3",
        "value": "Norfolk Island",
        "label": "Norfolk Island"
    },
    {
        "countryCode": "+1 670",
        "value": "Northern Mariana Islands",
        "label": "Northern Mariana Islands"
    },
    {
        "countryCode": "+47",
        "value": "Norway",
        "label": "Norway"
    },
    {
        "countryCode": "+968",
        "value": "Oman",
        "label": "Oman"
    },
    {
        "countryCode": "+92",
        "value": "Pakistan",
        "label": "Pakistan"
    },
    {
        "countryCode": "+680",
        "value": "Palau",
        "label": "Palau"
    },
    {
        "countryCode": "+970",
        "value": "Palestine, State of",
        "label": "Palestine, State of"
    },
    {
        "countryCode": "+507",
        "value": "Panama",
        "label": "Panama"
    },
    {
        "countryCode": "+675",
        "value": "Papua New Guinea",
        "label": "Papua New Guinea"
    },
    {
        "countryCode": "+595",
        "value": "Paraguay",
        "label": "Paraguay"
    },
    {
        "countryCode": "+51",
        "value": "Peru",
        "label": "Peru"
    },
    {
        "countryCode": "+63",
        "value": "Philippines",
        "label": "Philippines"
    },
    {
        "countryCode": "+48",
        "value": "Poland",
        "label": "Poland"
    },
    {
        "countryCode": "+351",
        "value": "Portugal",
        "label": "Portugal"
    },
    {
        "countryCode": "+1 787, 1 939",
        "value": "Puerto Rico",
        "label": "Puerto Rico"
    },
    {
        "countryCode": "+974",
        "value": "Qatar",
        "label": "Qatar"
    },
    {
        "countryCode": "+262",
        "value": "Réunion",
        "label": "Réunion"
    },
    {
        "countryCode": "+40",
        "value": "Romania",
        "label": "Romania"
    },
    {
        "countryCode": "+250",
        "value": "Rwanda",
        "label": "Rwanda"
    },
    {
        "countryCode": "+590",
        "value": "Saint Barthélemy",
        "label": "Saint Barthélemy"
    },
    {
        "countryCode": "+1 869",
        "value": "Saint Kitts and Nevis",
        "label": "Saint Kitts and Nevis"
    },
    {
        "countryCode": "+1 758",
        "value": "Saint Lucia",
        "label": "Saint Lucia"
    },
    {
        "countryCode": "+508",
        "value": "Saint Pierre and Miquelon",
        "label": "Saint Pierre and Miquelon"
    },
    {
        "countryCode": "+1 784",
        "value": "Saint Vincent and the Grenadines",
        "label": "Saint Vincent and the Grenadines"
    },
    {
        "countryCode": "+685",
        "value": "Samoa",
        "label": "Samoa"
    },
    {
        "countryCode": "+378",
        "value": "San Marino",
        "label": "San Marino"
    },
    {
        "countryCode": "+966",
        "value": "Saudi Arabia",
        "label": "Saudi Arabia"
    },
    {
        "countryCode": "+221",
        "value": "Senegal",
        "label": "Senegal"
    },
    {
        "countryCode": "+381",
        "value": "Serbia",
        "label": "Serbia"
    },
    {
        "countryCode": "+248",
        "value": "Seychelles",
        "label": "Seychelles"
    },
    {
        "countryCode": "+232",
        "value": "Sierra Leone",
        "label": "Sierra Leone"
    },
    {
        "countryCode": "+65",
        "value": "Singapore",
        "label": "Singapore"
    },
    {
        "countryCode": "+421",
        "value": "Slovakia",
        "label": "Slovakia"
    },
    {
        "countryCode": "+386",
        "value": "Slovenia",
        "label": "Slovenia"
    },
    {
        "countryCode": "+677",
        "value": "Solomon Islands",
        "label": "Solomon Islands"
    },
    {
        "countryCode": "+252",
        "value": "Somalia",
        "label": "Somalia"
    },
    {
        "countryCode": "+27",
        "value": "South Africa",
        "label": "South Africa"
    },
    {
        "countryCode": "+211",
        "value": "South Sudan",
        "label": "South Sudan"
    },
    {
        "countryCode": "+34",
        "value": "Spain",
        "label": "Spain"
    },
    {
        "countryCode": "+94",
        "value": "Sri Lanka",
        "label": "Sri Lanka"
    },
    {
        "countryCode": "+249",
        "value": "Sudan",
        "label": "Sudan"
    },
    {
        "countryCode": "+597",
        "value": "Suriname",
        "label": "Suriname"
    },
    {
        "countryCode": "+46",
        "value": "Sweden",
        "label": "Sweden"
    },
    {
        "countryCode": "+41",
        "value": "Switzerland",
        "label": "Switzerland"
    },
    {
        "countryCode": "+886",
        "value": "Taiwan",
        "label": "Taiwan"
    },
    {
        "countryCode": "+992",
        "value": "Tajikistan",
        "label": "Tajikistan"
    },
    {
        "countryCode": "+66",
        "value": "Thailand",
        "label": "Thailand"
    },
    {
        "countryCode": "+228",
        "value": "Togo",
        "label": "Togo"
    },
    {
        "countryCode": "+690",
        "value": "Tokelau",
        "label": "Tokelau"
    },
    {
        "countryCode": "+676",
        "value": "Tonga",
        "label": "Tonga"
    },
    {
        "countryCode": "+1 868",
        "value": "Trinidad and Tobago",
        "label": "Trinidad and Tobago"
    },
    {
        "countryCode": "+216",
        "value": "Tunisia",
        "label": "Tunisia"
    },
    {
        "countryCode": "+90",
        "value": "Turkey",
        "label": "Turkey"
    },
    {
        "countryCode": "+993",
        "value": "Turkmenistan",
        "label": "Turkmenistan"
    },
    {
        "countryCode": "+1 649",
        "value": "Turks and Caicos Islands",
        "label": "Turks and Caicos Islands"
    },
    {
        "countryCode": "+688",
        "value": "Tuvalu",
        "label": "Tuvalu"
    },
    {
        "countryCode": "+256",
        "value": "Uganda",
        "label": "Uganda"
    },
    {
        "countryCode": "+380",
        "value": "Ukraine",
        "label": "Ukraine"
    },
    {
        "countryCode": "+971",
        "value": "United Arab Emirates",
        "label": "United Arab Emirates"
    },
    {
        "countryCode": "+44",
        "value": "United Kingdom",
        "label": "United Kingdom"
    },
    {
        "countryCode": "+1",
        "value": "United States",
        "label": "United States"
    },
    {
        "countryCode": "+598",
        "value": "Uruguay",
        "label": "Uruguay"
    },
    {
        "countryCode": "+998",
        "value": "Uzbekistan",
        "label": "Uzbekistan"
    },
    {
        "countryCode": "+678",
        "value": "Vanuatu",
        "label": "Vanuatu"
    },
    {
        "countryCode": "+84",
        "value": "Vietnam",
        "label": "Vietnam"
    },
    {
        "countryCode": "+681",
        "value": "Wallis and Futuna",
        "label": "Wallis and Futuna"
    },
    {
        "countryCode": "+967",
        "value": "Yemen",
        "label": "Yemen"
    },
    {
        "countryCode": "+260",
        "value": "Zambia",
        "label": "Zambia"
    },
    {
        "countryCode": "+263",
        "value": "Zimbabwe",
        "label": "Zimbabwe"
    }
]